import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import { LinkProps } from "@mui/material";

export const RouterLinkAdapter = React.forwardRef<any, any>(
  function RouterLinkAdapter({ href, ...rest }: Omit<LinkProps, "color">, ref) {
    if (!href) {
      // React router's Link gets cranky without an href, and throws.
      // If there is no href to translate to the link, just use a div.
      // The navigation will of course not work - like any other link
      // without an href - but at least it will render correctly and not
      // break the page.
      return <Box component="span" ref={ref} {...rest} />;
    }
    return <ReactRouterLink ref={ref} to={href} {...rest} />;
  }
);
